<div *ngIf="functionService?.selectedLanguageCode && languages?.length > 1"
  class="d-flex justify-content-center align-items-center h-100 w-100">
  <ng-container
    *ngTemplateOutlet="languageDropdown; context: { code: isSetLanguageCode ? functionService.selectedLanguageCode : functionService.languageTempCode }"></ng-container>
</div>

<ng-template #languageDropdown let-code="code">
  <div class="dropdown-container">
    <!-- Nút bấm mở dropdown -->
    <div class="dropdown-toggle d-flex flex-row align-items-center" (click)="toggleDropdown()">
      <img onerror="this.src='/assets/root/images/system/icons/image_default.svg'" [alt]="code"
        [src]="'/assets/root/images/system/flags/'+ code?.toLowerCase() + '.svg'" width="24px" height="18px">
    </div>

    <!-- Danh sách ngôn ngữ -->
    <ul *ngIf="isDropdownOpen" class="dropdown-modal">
      <li *ngFor="let item of languages" class="dropdown-item d-flex flex-row align-items-center"
        (click)="onLanguageChange(item)" [ngStyle]="{ background: code === item?.code ? '#ccc' : '' }">
        <p class="m-0" [ngStyle]="{ fontWeight: code === item?.code ? '600' : '500' }">{{ item.name }}</p>
        <img onerror="this.src='/assets/root/images/system/icons/image_default.svg'" [alt]="item?.code"
          [src]="'/assets/root/images/system/flags/'+ item?.code?.toLowerCase() + '.svg'" width="20px" height="15px">
      </li>
    </ul>
  </div>
</ng-template>